import {
  HIS_ACCOUNTANT,
  HIS_ADMIN,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_CHIEF_TECHNICIAN,
  HIS_DOCTOR,
  HIS_READ_ONLY,
  HIS_SALES_CONSULTANT,
  HIS_SUPER_ADMIN,
  HIS_TECHNICIAN,
  HIS_TOUR_RECONCILIATION,
  PathModule,
} from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const AccountantRoute = {
  path: PathModule.ACCOUNTANT,
  exact: true,
  auth: [
    HIS_ADMIN,
    HIS_SALES_CONSULTANT,
    HIS_BRANCH_MANAGER,
    HIS_CASHIER,
    HIS_DOCTOR,
    HIS_CHIEF_TECHNICIAN,
    HIS_TECHNICIAN,
    HIS_READ_ONLY,
    HIS_ACCOUNTANT,
  ],

  children: [
    {
      path: "report-by-payment-method",
      auth: [
        HIS_SUPER_ADMIN,
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportPayment/ReportPaymentIndex"),
      }),
    },
    {
      path: "report-expense",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportExpense/ReportExpenseIndex"),
      }),
    },

    {
      path: "report-sales-allocation",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CHIEF_TECHNICIAN,
      //   HIS_TECHNICIAN,
      //   HIS_CASHIER,
      //   HIS_READ_ONLY
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationIndex"
          ),
      }),
    },
    {
      path: "report-revenue-allocation",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueAllocation/ReportRevenueAllocationIndex"
          ),
      }),
    },
    {
      path: "report-debt",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportDebt/ReportDebtIndex"),
      }),
    },
    {
      path: "report-checkin",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportCheckin/ReportCheckinIndex"),
      }),
    },

    {
      path: "treatment-report",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_SUPER_ADMIN,
        HIS_DOCTOR,
        HIS_SALES_CONSULTANT,
        HIS_TECHNICIAN,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentReport/TreatmentReportIndex"
          ),
      }),
    },
    {
      path: "staff-revenue-payment-revenue",
      auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_ACCOUNTANT],
      //auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/Accountant/ReconcileAllocatedRevenue/ReconcileAllocatedRevenueIndex"
          ),
      }),
    },

    {
      path: "staff-revenue-payment-sale",
      auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_ACCOUNTANT],
      //auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/Accountant/ReconcileAllocatedRevenue/ReconcileAllocatedSalesIndex"
          ),
      }),
    },
    {
      path: "check-suggest-fee",
      auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_ACCOUNTANT, HIS_TOUR_RECONCILIATION],
      //auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/Accountant/CheckSuggestFees/CheckSuggestFeesIndex"),
      }),
    },
    {
      path: "voucher-item-report",
      auth: [
        HIS_ADMIN,
        HIS_SUPER_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/VoucherItemReport/VoucherItemReportIndex"
          ),
      }),
    },
    {
      path: "revenue-details-report",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueDetails/ReportRevenueDetailsIndex"
          ),
      }),
    },
    {
      path: "report-get-revenue-detail",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueDetail/ReportRevenueDetailIndex"
          ),
      }),
    },
    {
      path: "report-employee-revenue-allocation-summary",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportEmployeeRevenueAllocationSummary/ReportOverview/ReportOverviewIndex"
          ),
      }),
    },
    {
      path: "revenue-summary-by-employee",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportEmployeeRevenueAllocationSummary/RevenueSummaryByEmployee/RevenueSummaryByEmployeeIndex"
          ),
      }),
    },
    {
      path: "embedded-iframe",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/EmbeddedIFrame/EmbeddedIFrameIndex"),
      }),
    },
  ],
};
export default AccountantRoute;
